
export default function FacilitiesSection() {
  const facilities = [
    {
      title: "Outdoor Training Fields",
      description: "Three full-size grass fields with professional drainage and lighting systems for year-round training.",
      features: ["FIFA-standard grass surfaces", "Professional lighting", "Spectator seating", "Equipment storage"]
    },
    {
      title: "Indoor Training Center",
      description: "Climate-controlled indoor facility for technical training, conditioning, and year-round development.",
      features: ["Artificial turf surface", "Video analysis room", "Strength training area", "Recovery lounge"]
    },
    {
      title: "Youth Development Areas",
      description: "Specialized smaller fields designed specifically for younger players to develop fundamental skills.",
      features: ["Age-appropriate field sizes", "Safety padding", "Mini goals", "Skill development stations"]
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">World-Class Facilities</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Our state-of-the-art training facilities provide the perfect environment for player development at every level.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-12">
          <div>
            <img 
              src="https://public.readdy.ai/ai/img_res/741f261fcb7e970f1860f33688325e65.jpg"
              alt="NextZen Soccer Academy Facilities"
              className="w-full h-80 object-cover rounded-lg shadow-lg"
            />
          </div>
          <div>
            <h3 className="text-2xl font-bold text-gray-900 mb-4">Premier Training Environment</h3>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              Located in the heart of Folsom, CA, our 15-acre facility features everything needed to develop soccer excellence. From professional-grade fields to cutting-edge training equipment, we provide an environment where players can thrive.
            </p>
            <div className="grid grid-cols-2 gap-4">
              <div className="text-center p-4 bg-gray-50 rounded-lg">
                <div className="text-2xl font-bold text-purple-600">15</div>
                <p className="text-sm text-gray-600">Acres</p>
              </div>
              <div className="text-center p-4 bg-gray-50 rounded-lg">
                <div className="text-2xl font-bold text-purple-600">4</div>
                <p className="text-sm text-gray-600">Training Fields</p>
              </div>
              <div className="text-center p-4 bg-gray-50 rounded-lg">
                <div className="text-2xl font-bold text-purple-600">1</div>
                <p className="text-sm text-gray-600">Indoor Center</p>
              </div>
              <div className="text-center p-4 bg-gray-50 rounded-lg">
                <div className="text-2xl font-bold text-purple-600">200+</div>
                <p className="text-sm text-gray-600">Parking Spots</p>
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {facilities.map((facility, index) => (
            <div key={index} className="bg-gray-50 p-6 rounded-lg">
              <h4 className="text-xl font-semibold text-gray-900 mb-3">{facility.title}</h4>
              <p className="text-gray-700 mb-4">{facility.description}</p>
              <ul className="space-y-2">
                {facility.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-center text-sm text-gray-600">
                    <i className="ri-check-line text-green-500 mr-2"></i>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-purple-600 text-white p-8 rounded-lg text-center">
          <h3 className="text-2xl font-bold mb-4">Visit Our Facilities</h3>
          <p className="text-lg mb-6">
            Experience our world-class training environment firsthand. Schedule a tour and see why NextZen is Folsom's premier soccer academy.
          </p>
          <button className="bg-white text-purple-600 px-8 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap">
            Schedule a Tour
          </button>
        </div>
      </div>
    </section>
  );
}
